import type { ExtendedMaterial, Material } from '@buying/library';

const extractMaterialThumbnailUrl = (
    material: ExtendedMaterial | Material | null | undefined
): string | undefined =>
    material?.materialAttachment
        ? `data:${material.materialAttachment.format};base64,${material.materialAttachment.attachmentContent}`
        : undefined;

export { extractMaterialThumbnailUrl };
